import { apiClient } from './showcaseApi';
import type { WatchListResponse } from '../types/showcase';

/**
 * watchApi — queue #677 §UAT-2026-07-13-R677 §R677-3.
 * `GET`/`PUT`/`DELETE /api/eraf/showcase/watches[/{moduleCode}]` — 본인 구독(워치) 목록
 * 조회 · 단건 토글(멱등). `showcaseApi.ts` 의 `apiClient`(Bearer 자동 첨부 · ApiResponse
 * 언랩 · ApiError 정규화)를 그대로 재사용한다(신규 HTTP 클라이언트 구현 없음 · #12).
 */
export const watchApi = {
  /** GET /api/eraf/showcase/watches — 본인 구독 코드 목록 */
  list: (): Promise<WatchListResponse> =>
    apiClient
      .get<unknown, { data: WatchListResponse }>('/showcase/watches')
      .then((res) => res.data),

  /** PUT /api/eraf/showcase/watches/{moduleCode} — 구독(멱등) · 갱신된 전체 목록 반환 */
  watch: (moduleCode: string): Promise<WatchListResponse> =>
    apiClient
      .put<unknown, { data: WatchListResponse }>(`/showcase/watches/${moduleCode}`)
      .then((res) => res.data),

  /** DELETE /api/eraf/showcase/watches/{moduleCode} — 구독 해제(멱등) · 갱신된 전체 목록 반환 */
  unwatch: (moduleCode: string): Promise<WatchListResponse> =>
    apiClient
      .delete<unknown, { data: WatchListResponse }>(`/showcase/watches/${moduleCode}`)
      .then((res) => res.data),
};
